<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-vch-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-vch-badge">Voucher</span>

  <div class="cr-vch-row">
    <div
      class="cr-vch-dropzone"
      [appInlineMedia]="block.variables?.['VoucherImage']"
      [inlineMediaBlockId]="block.blockId"
      (inlineMediaChange)="onChange($event, 'VoucherImage')"
    >
      <img *ngIf="block.variables?.['VoucherImage']; else emptyPreview" [src]="block.variables?.['VoucherImage']" [alt]="block.variables?.['VoucherAlt'] || ''" />

      <ng-template #emptyPreview>
        <div class="cr-inline-media-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-inline-media-title">Upload image</div>
        <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
      </ng-template>
    </div>

    <div class="cr-vch-content">
      <span
        class="cr-vch-heading"
        [appInlineEdit]="block.variables?.VoucherHeading ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert voucher heading"
        (inlineEditChange)="onChange($event, 'VoucherHeading')"
      ></span>

      <span
        class="cr-vch-text"
        [appInlineEdit]="block.variables?.VoucherText ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert voucher text"
        (inlineEditChange)="onChange($event, 'VoucherText')"
      ></span>

      <a class="cr-vch-cta" [href]="ctaPreviewHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.VoucherCtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'VoucherCtaText')"
        ></span>
      </a>
    </div>
  </div>

  <span
    class="cr-vch-paragraph"
    [appInlineEdit]="block.variables?.VoucherParagraph ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert voucher paragraph"
    [inlineEditMultiline]="true"
    (inlineEditChange)="onChange($event, 'VoucherParagraph')"
  ></span>
</div>

<!-- Right panel: real edit form -->
<div class="cr-vch-edit" *ngIf="!isPreview">
  <div class="cr-vch-field-row">
    <span class="cr-vch-field-label">Image</span>
    <span
      class="cr-vch-toggle"
      [class.cr-vch-toggle-on]="imageAsUpload"
      role="button"
      tabindex="0"
      [title]="imageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleImageMode()"
      (keydown.enter)="toggleImageMode()"
      (keydown.space)="toggleImageMode()"
    ></span>
  </div>
  <div class="cr-vch-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['VoucherImage'] ?? ''"
      (handleOnChange)="onChange($event, 'VoucherImage')"
      [placeholder]="imagePlaceholder"
      variable="VoucherImage"
      [isImage]="imageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-vch-empty-overlay" *ngIf="imageAsUpload && !block.variables?.['VoucherImage']">
      <div class="cr-vch-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-vch-title">Upload image</div>
      <div class="cr-vch-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <app-field-editor-v2
    type="alt"
    [blockData]="block.variables?.['VoucherAlt'] ?? ''"
    (handleOnChange)="onChange($event, 'VoucherAlt')"
    [placeholder]="imageAltPlaceholder"
    [maxLength]="500"
    variable="VoucherAlt"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['VoucherHeading'] ?? ''"
    (handleOnChange)="onChange($event, 'VoucherHeading')"
    [placeholder]="headingPlaceholder"
    [maxLength]="500"
    variable="VoucherHeading"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['VoucherText'] ?? ''"
    (handleOnChange)="onChange($event, 'VoucherText')"
    [placeholder]="textPlaceholder"
    [maxLength]="500"
    variable="VoucherText"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <div class="cr-vch-link-field">
    <app-field-editor-v2
      type="action-link"
      [blockData]="block.variables?.['VoucherLink'] ?? ''"
      (handleOnChange)="onChange($event, 'VoucherLink')"
      [placeholder]="linkPlaceholder"
      [maxLength]="500"
      variable="VoucherLink"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'VoucherLinkSegmentRegex')"
      [selectedSegment]="block.variables?.['VoucherLinkSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['VoucherCtaText'] ?? ''"
    (handleOnChange)="onChange($event, 'VoucherCtaText')"
    [placeholder]="ctaTextPlaceholder"
    [maxLength]="30"
    variable="VoucherCtaText"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.['VoucherParagraph'] ?? ''"
    (handleOnChange)="onChange($event, 'VoucherParagraph')"
    [placeholder]="paragraphPlaceholder"
    [maxLength]="4000"
    variable="VoucherParagraph"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
